
import React, { useEffect } from 'react';
import PageLayout from '../components/layout/PageLayout';
import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import About from '../components/home/About';
import Portfolio from '../components/home/Portfolio';
import Testimonials from '../components/home/Testimonials';
import Contact from '../components/home/Contact';
import { createLocalBusinessSchema, createServiceSchema, astremBusinessData } from '../utils/seoUtils';
import { updateMetaTags } from '../utils/ottoSeoUtils';

// Default OG image for pages that don't specify one - using absolute URL
const DEFAULT_OG_IMAGE = "https://portal.astrem.co/users/u9/9466/astremagency/lovableagentsite/astrem_og_Websites%20Content%20Marketing%20Solutions.jpg";

// SEO-optimized description for homepage
const HOME_META_DESCRIPTION = "Boost your business with Astrem’s web design, branding, SEO, and virtual tours in Baton Rouge, LA. Elevate your presence today—get a free strategy call!";

const Index = () => {
  // Force update meta tags on mount for the homepage
  useEffect(() => {
    // Double-check that meta description is set correctly on home page
    updateMetaTags({
      title: "Website Design, Photography & Marketing | Baton Rouge, LA | Astrem",
      description: HOME_META_DESCRIPTION,
      type: 'website',
      imageUrl: "https://portal.astrem.co/users/u9/9466/astremagency/lovableagentsite/astrem_og_Websites%20Content%20Marketing%20Solutions.jpg",
      canonicalUrl: "https://astrem.co/"
    });
  }, []);

  // Create rich schema data for homepage
  const localBusinessSchema = createLocalBusinessSchema(astremBusinessData);
  
  // Main services offered
  const mainServices = [
    {
      name: "Website Design",
      description: "Professional website design services for businesses and organizations. Stand out from the crowd with a website that attracts and converts customers.",
      provider: {
        name: "Astrem",
        url: "https://astrem.co"
      },
      url: "https://astrem.co/services/website-design"
    },
    {
      name: "Photography Services",
      description: "Expert photography services for businesses, real estate, events, and more.",
      provider: {
        name: "Astrem",
        url: "https://astrem.co"
      },
      url: "https://astrem.co/services/photography"
    },
    {
      name: "Marketing Services",
      description: "Digital marketing services for businesses looking to grow their online presence and attract more customers.",
      provider: {
        name: "Astrem",
        url: "https://astrem.co"
      },
      url: "https://astrem.co/services/marketing"
    }
  ];

  return (
    <PageLayout
      title="About Us | Baton Rouge Web Design & Marketing Experts"
      description={HOME_META_DESCRIPTION}
      ogImage="https://portal.astrem.co/users/u9/9466/astremagency/lovableagentsite/astrem_og_Websites%20Content%20Marketing%20Solutions.jpg"
      canonicalPath="/"
      schemaData={[localBusinessSchema, ...mainServices.map(service => createServiceSchema(service))]}
    >
      <main className="flex-grow">
        <Hero />
        <Services />
        <About />
        <Portfolio />
        <Testimonials />
        <Contact />
      </main>
    </PageLayout>
  );
};

// Helper function to set OG meta tags (exported for use in other files)
export const setOGMetaTags = (title: string, description: string, imageUrl?: string) => {
  // Update meta tags using the OTTO utility
  updateMetaTags({
    title,
    description,
    imageUrl: imageUrl || DEFAULT_OG_IMAGE
  });
};

export default Index;
